import { Link } from 'react-router-dom';
import { practiceAreas } from '@/mocks/firm';

export default function PracticePreview() {
  return (
    <section className="px-4 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-secondary-500 text-xs uppercase tracking-[0.25em] mb-3 font-semibold">servicios legales específicos</p>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 max-w-xl leading-tight">Nuestra experiencia profesional</h2>
          </div>
          <Link to="/about#servicios" className="text-sm font-semibold text-primary-500 hover:text-primary-700 whitespace-nowrap cursor-pointer flex items-center gap-2">Ver todos los servicios <i className="ri-arrow-right-line"></i></Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {practiceAreas.map((p) => (
            <Link key={p.title} to={p.href} className="group bg-background-50 border border-background-200 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-colors cursor-pointer">
              <span className="w-12 h-12 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-2xl font-semibold mt-5 text-foreground-950">{p.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mt-2 whitespace-pre-line">{p.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-secondary-600 mt-5">Leer más <i className="ri-arrow-right-up-line"></i></span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}